import {HttpErrorResponse, HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {inject} from '@angular/core';
import {ToastService} from '@services/toast.service';
import {environment} from '@env/environment';
import {PlannerApi} from '@api/planner';

export function toastInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const toastService = inject(ToastService);

  return next(request).pipe(
    tap(httpEvent => {
      if (
        httpEvent.type === HttpEventType.Response &&
        httpEvent.ok &&
        httpEvent.body &&
        typeof httpEvent.body === 'object' &&
        'message' in httpEvent.body &&
        typeof httpEvent.body?.message === 'string'
      ) {
        toastService.success(httpEvent.body.message);
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.url?.startsWith(environment.apiBaseUrl)) {
        const errorMessage = PlannerApi.extractErrorMessage(error);

        switch (error.status) {
          case 0:
            toastService.error('Request has been denied by the server');
            break;

          case 400:
            toastService.error(errorMessage, 'Validation Error');
            break;

          case 401:
            // Auth interceptor handles 401 redirects, just show message
            toastService.warning('Session has expired');
            break;

          case 403:
            toastService.error('You do not have permission to perform this action');
            break;

          case 404:
            toastService.error('The requested resource was not found');
            break;

          case 500:
            toastService.error(errorMessage, 'Server Error');
            break;

          default:
            toastService.error(errorMessage);
            break;
        }
      }

      return throwError(() => error);
    }),
  );
}
